import * as types from '../types';

export const i18nMutations = {
  [types.SET_SYSTEM_LANGUAGE](state, payload) {
    state.systemLanguage.locale = payload.value;
    state.systemLanguage.language = payload.text;
    
    state.systemLanguage.loadedSections[state.systemLanguage.locale] = [
      ...state.systemLanguage.sections
    ];
    console.log({'mutations.js:9 state.systemLanguage.loadedSections' : state.systemLanguage.loadedSections});
  },
  [types.INSERT_SYSTEM_LANGUAGE_SECTION](state, payload) {
    state.systemLanguage.sections = Array.from(new Set([...state.systemLanguage.sections, ...payload])).filter(e => e);
    state.systemLanguage.loadedSections[state.systemLanguage.locale] = [
      ...state.systemLanguage.sections
    ];
    console.log({'mutations.js:17 state.systemLanguage.sections' : state.systemLanguage.sections});
    console.log({'mutations.js:16 state.systemLanguage.loadedSections' : state.systemLanguage.loadedSections});
  },
}